<template>
  <div>
    <h1>DEMO SIDE FOLLOW UP</h1>
    <v-layout wrap class="blue lighten-5">
      <v-flex xs12>
        <h2 class="pa-3">Siste nytt</h2>
      </v-flex>
      <v-flex xs12 sm4 v-for="x in News" :key="x.id">
        <v-hover>
          <v-card style="cursor:pointer;" class="ma-3" tile @click="showNewsDialog(x)">
            <v-layout class wrap>
              <v-flex xs6 sm3>
                <v-img
                  v-if="x.mediaurl"
                  class="mr-3"
                  :src="x.mediaurl"
                  aspect-ratio="1"
                  auto-sizing
                />
              </v-flex>
              <v-flex xs6 sm9 class>
                <p class="title">{{x.title}}</p>
                <p v-html="x.content"></p>
              </v-flex>
            </v-layout>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
    <v-dialog v-model="newsDialog" width="500">
      <v-card>
        <v-card-title>
          <v-layout wrap>
            <v-flex
              xs12
              v-if="currentNews.mediaurl"
              :class="{'mr-3' : $vuetify.breakpoint.smAndUp}"
            >
              <v-img :src="currentNews.mediaurl"></v-img>
            </v-flex>
            <v-flex>
              <div class="display-1">{{currentNews.title}}</div>
              <div v-html="currentNews.content"></div>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsDialog: false,
      News: [],
      currentNews: {}
    };
  },
  methods: {
    showNewsDialog(news) {
      this.currentNews = news;
      this.newsDialog = true;
    },
    fetchNews() {
      let _url = `https://followup.dev.prios.no/api/news/b6750f2a-e773-403c-b5a6-642b33e76493`;
      axios
        .get(_url)
        .then(resp => {
          this.News = [];
          if (resp.data.length > 0) {
            for (var i = 0; i < resp.data.length && i < 3; i++) {
              this.News.push(resp.data[i]);
            }
          }
        })
        .catch(err => {
          console.log({ err });
          reject(err);
        });
    }
  },
  mounted() {
    this.fetchNews();
  }
};
</script>

<style scoped>
</style>
